import styles from "./index.module.scss";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useState } from "react";
import globalStyles from "../../styles/_stylesParams.module.scss";
import Stack from "@mui/material/Stack";
import pxToRem from "../../helpers/pxToRem";

const style = { position: "absolute" as "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: pxToRem(600), boxShadow: `0px ${pxToRem(4)} ${pxToRem(4)} 0px rgba(0, 0, 0, 0.25)`, };
export type ModalType = "ERROR" | "DEFAULT";
export interface ICustomizedModal { open: boolean; handleClose: () => void; children: JSX.Element; className?: string; ovstyle?:React.CSSProperties }
const CustomizedModal = ({ open, handleClose, children, className, ovstyle }: ICustomizedModal) => (
    <Modal open={open} onClose={handleClose} aria-labelledby='modal-modal-title' aria-describedby='modal-modal-description' className={className ?? ""} >
        <Stack sx={style} className={styles.modalContentWrapper} style={ovstyle??{}}>
            <div>{children}</div>
        </Stack>
    </Modal>
);

export default CustomizedModal;
